import React, { useState, useRef } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請填寫您的手機或信箱',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  // const visibleIfConditionsInit = {
  //   q4: '{q3} = 0',
  //   q5: '{q3} = 0',
  //   q6: '{q3} = 1',
  //   q7: '{q3} = 1',
  //   q8: '{q3} = 1',
  //   q9: '{q3} = 1',
  //   q10: '{q3} = 1',
  //   q11: '{q3} = 1',
  //   q12: '{q3} = 1',
  //   q13: '{q3} = 1',
  //   q14: '{q3} = 1',
  //   q15: '{q3} = 1',
  //   q16: '{q5} = 0 or {q5} = 1',
  //   q17: '{q5} = 0 or {q5} = 1',
  //   q18: '{q5} = 0 or {q5} = 1',
  //   q19: '{q5} = 0 or {q5} = 1',
  //   q20: '{q5} = 0 or {q5} = 1',
  //   q21: '{q5} = 0 or {q5} = 1',
  //   q22: '{q5} = 0 or {q5} = 1',
  //   q23: '{q5} = 0 or {q5} = 1',
  //   q24: '{q5} = 0 or {q5} = 1',
  //   q25: '{q5} = 0 or {q5} = 1',
  //   q26: '{q5} = 0 or {q5} = 1',
  //   q27: '{q5} = 0 or {q5} = 1',
  //   q28: '{q5} = 0 or {q5} = 1',
  //   q29: '{q5} = 0 or {q5} = 1',
  //   q30: '{q5} = 1',
  //   q31: '{q5} = 1',
  //   q35: '{q34} anyof [1]',
  //   q36: '{q34} anyof [2]',
  //   q43: '{q42} = 0',
  // }

  const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  // const triggersConditionsInit = [
  //   {
  //     type: 'complete',
  //     expression: '({q0} = 0) or ({q1} = 1) or ({q2} = 1)',
  //     //     expression: `{q3} <> 4 or ({q4} = 16 or {q4} = 20 or {q4} = 21)`,
  //   },
  // ]
  const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
  })

  const newSurvey = new Model(convertedSurvey)
  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  // 帶入選項
  // const questionMappings = {
  //   q29: 'q31',
  // }

  function helpFunction(survey, options) {
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const canShowPrevButtonPages = [1, 2, 3]
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})

  useSubmitAnswers({
    survey: newSurvey,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
  })

  return (
    <>
      {convertedSurvey ? (
        <Survey model={newSurvey} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
